import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7OPCVMUnderlyingTSSchema = z.object({
  date_equals: z.string().optional(),
  underlying_id_equals: z.string().optional(),
  denomination_fonds_contains: z.string().optional(),
});

export type FilterA7OPCVMUnderlyingTSSchema = z.infer<
  typeof filterA7OPCVMUnderlyingTSSchema
>;

const initialFields: Field[] = [
  {
    name: "date_equals",
    label: `Date`,
    type: "autocomplete",
    options: [],
  },
  {
    name: "underlying_id_equals",
    label: `Instrument financiter`,
    type: "input",
  },
  {
    name: "denomination_fonds_contains",
    label: `Émetteur`,
    type: "input",
  },
];

export function FilterA7OPCVMUnderlyingTS({
  table_name,
}: {
  table_name: string;
}) {
  const { fields } = useDateOptions("a7", table_name, initialFields);

  return (
    <FilterTable
      schema={filterA7OPCVMUnderlyingTSSchema}
      tableName="a7_opcvm_underlying_ts"
      fields={fields}
      client="a7"
      customBuildPath={() => `a7-opcvm/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
